import { useCart } from '@shopify/hydrogen';
import { FC } from 'react';
import { ReactComponent as Cart } from '../../assets/icon/cart.svg';

export const CartIcon: FC = () => {
  const { totalQuantity } = useCart();

  return (
    <div className="relative inline-block align-middle">
      <Cart />
      {totalQuantity > 0 && (
        <span className="absolute top-[-4px] right-[-10px] block h-[16px] w-[16px] rounded-full bg-link text-center text-xs font-semibold text-white">
          {totalQuantity}
        </span>
      )}
    </div>
  );
};
